import * as React from 'react'
import FiltersBar from '@mulesoft/monitoring-center-components/lib/components/FiltersBar/FiltersBar'
import { DropdownFilter, FilterType } from '@mulesoft/monitoring-center-components/lib/models/filters-bar'
import { alertSeverityFilterOptions, alertStateFilterOptions, alertTypeFilterOptions } from './filters'
import { AlertsFilters } from '../model'

export type Props = {
  filters: AlertsFilters
  onChange: (key: string, value: any) => void
  isAlertTypeFilterEnabled: boolean
}

function getSelectedState(props: Props) {
  const state = alertStateFilterOptions.find(r => r.key === (props.filters.state))
  return state || alertStateFilterOptions[0]
}

function getSelectedSeverity(props: Props) {
  const state = alertSeverityFilterOptions.find(r => r.key === (props.filters.severity))
  return state || alertSeverityFilterOptions[0]
}

// function getSelectedResource(props: Props) {
//   const state = alertResourceFilterOptions.find(r => r.key === (props.filters.resource))
//   return state || alertResourceFilterOptions[0]
// }

function stateFilter(props: Props): DropdownFilter {
  const currentState = getSelectedState(props)
  return {
    filterType: FilterType.Dropdown,
    key: 'state',
    options: alertStateFilterOptions,
    placeholder: currentState.label,
    value: currentState.key,
    className: 'state-filter',
    testId: 'alert-state-dropdown'
  }
}

function severityFilter(props: Props): DropdownFilter {
  const currentSeverity = getSelectedSeverity(props)
  return {
    filterType: FilterType.Dropdown,
    key: 'severity',
    options: alertSeverityFilterOptions,
    placeholder: currentSeverity.label,
    value: currentSeverity.key,
    className: 'severity-filter',
    testId: 'alert-severity-dropdown'
  }
}

function getSelectedType(props: Props) {
  const type = alertTypeFilterOptions.find(r => r.key === (props.filters.type))
  return type || alertTypeFilterOptions[0]
}

function typeFilter(props: Props): DropdownFilter {
  const currentType = getSelectedType(props)
  return {
    filterType: FilterType.Dropdown,
    key: 'type',
    options: alertTypeFilterOptions,
    placeholder: currentType.label,
    value: currentType.key,
    className: 'alert-type-filter',
    testId: 'alert-type-dropdown'
  }
}

// function resourceFilter(props: Props): DropdownFilter {
//   const currentResourceType = getSelectedResource(props)
//   return {
//     filterType: FilterType.Dropdown,
//     key: 'resource',
//     options: alertResourceFilterOptions,
//     placeholder: currentResourceType.label,
//     value: currentResourceType.key,
//     className: 'resource-filter',
//     testId: 'alert-resource-dropdown'
//   }
// }

function onFilterChange(props: Props) {
  return (key: string, value: any) => {
    props.onChange(key, value.key)
  }
}

export const AlertsListPageFilters = (props: Props) => {
  const filters = props.isAlertTypeFilterEnabled
    ? [stateFilter(props), severityFilter(props), typeFilter(props)]
    : [stateFilter(props), severityFilter(props)]
  const onChange = onFilterChange(props)

  return <FiltersBar filters={filters} onChange={onChange}/>
}
